module.exports = __webpack_public_path__ + "static/media/Notask1.e79c8106.png";